// One place that builds every URL, so a path change is a single edit
// (and later a single edit when moving to Next.js).
export const ROUTES = {
    home: (lang: string) => `/${lang}`,
    blog: (lang: string) => `/${lang}/blog`,
    blogPost: (lang: string, slug: string) => `/${lang}/blog/${slug}`,
    courses: (lang: string) => `/${lang}/course`,
    course: (lang: string, id: string | number) => `/${lang}/course/${id}`,
    rules: (lang: string) => `/${lang}/rules`,
    auth: (lang: string) => `/${lang}/auth`,
    myCourses: (lang: string) => `/${lang}/account/course`,
    purchaseCourse: (lang: string, id: string | number) =>
        `/${lang}/account/course/purchase/${id}`,
    myCourseContent: (lang: string, id: string | number) =>
        `/${lang}/account/course/${id}/content`,
    myCourseContentItem: (lang: string, courseId: string | number, contentId: string | number) =>
        `/${lang}/account/course/${courseId}/content/${contentId}`,
    myCourseCheatsheet: (lang: string, id: string | number) =>
        `/${lang}/account/course/${id}/cheatsheet`,
    myCourseCheatsheetItem: (lang: string, courseId: string | number, cheatsheetId: string | number) =>
        `/${lang}/account/course/${courseId}/cheatsheet/${cheatsheetId}`,
    blogEdit: (id: number | string) => `/admin/blog/edit/${id}`,
};